import type { HeroTextImage } from "services/cms/models";
import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { ResolvedImage } from "./imageResolver";
import imageResolver from "./imageResolver";
import richTextResolver, { ResolvedRichText } from "./richTextResolver";
import { checkRichTextIsNotEmpty } from "utils/checkRichTextIsNotEmpty";

export interface ResolvedheroTextImage {
    title?: ResolvedRichText;
    content: ResolvedRichText;
    buttonText?: string;
    buttonHref?: string;
    media: ResolvedImage;
    type: ContentTypeCodenames.HeroTextImage;
    codename: string;
}

const heroTextImageResolver = (data: HeroTextImage): ResolvedheroTextImage => {
    return {
        title: checkRichTextIsNotEmpty(data.elements.title.value)
            ? richTextResolver({
                  html: data.elements.title.value,
                  linkedItems: data.elements.title.linkedItems,
              })
            : undefined,
        content: richTextResolver({
            html: data.elements.copy.value,
            linkedItems: data.elements.copy.linkedItems,
        }),
        buttonText: data.elements.ctaLabel.value,
        buttonHref: data.elements.ctaLink.value,
        media: imageResolver(data.elements.image.linkedItems[0]),
        type: ContentTypeCodenames.HeroTextImage,
        codename: data.system.codename,
    };
};

export default heroTextImageResolver;
